const LAUNCH_COUNTRY_CODE_KEY = "launch_country_code";
const COUNTRY_HEADER = "x-country-code";
const LOCAL_COUNTRY_PATH = "/__country_code__";

let launchCountryCode: string | null = null;

function normalizeCountryCode(value: string | null): string | null {
  const normalized = value?.trim().toUpperCase() ?? "";
  return /^[A-Z]{2}$/.test(normalized) ? normalized : null;
}

export function setStoredLaunchCountryCode(countryCode: string): void {
  launchCountryCode = countryCode;
  localStorage.setItem(LAUNCH_COUNTRY_CODE_KEY, countryCode);
}

export function getStoredLaunchCountryCode(): string | null {
  if (launchCountryCode) return launchCountryCode;

  launchCountryCode = localStorage.getItem(LAUNCH_COUNTRY_CODE_KEY);
  return launchCountryCode;
}

export function clearStoredLaunchCountryCode(): void {
  launchCountryCode = null;
  localStorage.removeItem(LAUNCH_COUNTRY_CODE_KEY);
}

export async function initializeLaunchCountryCode(): Promise<string | null> {
  const requestUrl = import.meta.env.DEV ? LOCAL_COUNTRY_PATH : "/login";

  try {
    const response = await fetch(requestUrl, {
      cache: "no-store",
      credentials: "same-origin",
    });
    const countryCode = normalizeCountryCode(
      response.headers.get(COUNTRY_HEADER),
    );

    if (countryCode) {
      setStoredLaunchCountryCode(countryCode);
      return countryCode;
    }
  } catch (error) {
    console.warn("[Country] Unable to read launch country header:", error);
  }

  return normalizeCountryCode(getStoredLaunchCountryCode());
}
